import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../ui/Button';
import Table from '../../../ui/Table';
import AvatarImage from '../../../ui/AvatarImage';
import { getCreationOrValidationRequestsOrProposals } from '../../../apis/treasurer/treasurer';
import { useEffect, useState } from 'react';
import NoDataAvailable from '../../../ui/NoDataAvailable';
import Modal from '../../../ui/Modal';
import AcceptRequestModal from './AcceptRequestModal';
import Loader from '../../../ui/Loader';
import { useWallet } from '@solana/wallet-adapter-react';
import WalletConnectCustomButton from '../../walletconnectUI/WalletCustomText';
import { formatIntDateAndThenTime } from '../../../helpers/formatInDateAndThenTime';

function BountyValidationRequests({ multiSig }) {
    const navigate = useNavigate();
    const [validationRequests, setValidationRequests] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams();
    const { publicKey } = useWallet();
    const address = publicKey;
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    const data = await getCreationOrValidationRequestsOrProposals('BOUNTY_VALIDATION', id, false);
                    setValidationRequests(data);
                    setIsLoading(false);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [id]
    );

    const onRequestingFilterData = (id) => {
        const filterCreationData = validationRequests.filter((request) => request._id !== id);
        setValidationRequests(filterCreationData);
    };

    return (
        <>
            <Table.Header>
                <p className="text-sm   font-semibold text-secondaryText "> Bounty Name </p>
                <p className="text-sm   font-semibold text-secondaryText ">Requestor</p>
                <p className="text-sm   font-semibold text-secondaryText ">Request Time</p>
                <p className="text-sm   font-semibold text-secondaryText ">View Details</p>
                <p className="text-sm  font-semibold text-secondaryText ">Accept Request</p>
            </Table.Header>
            {isLoading ? (
                <div className="min-h-[20vh] flex justify-center items-center">
                    <Loader />
                </div>
            ) : validationRequests.length ? (
                validationRequests.map((overviewrow) => (
                    <Table.Row key={overviewrow._id}>
                        <p
                            onClick={() => navigate(`/organizations/${id}/view-bounties/${overviewrow.bountyId}`)}
                            className="text-textBrandBlue font-medium cursor-pointer "
                        >
                            {overviewrow.bountyTitle}
                        </p>
                        <div className="flex items-center gap-4 cursor-pointer ">
                            <AvatarImage w="w-[32px]" h="h-[32px]" url={overviewrow?.requesterProfileImage} />
                            <p className="text-textPrimary">{overviewrow.requesterUsername}</p>
                        </div>
                        <p className="text-textPrimary">{formatIntDateAndThenTime(overviewrow.createdAt)}</p>
                        <p
                            onClick={() =>
                                navigate(`request?bountyId=${overviewrow.bountyId}&reqId=${overviewrow._id} `)
                            }
                            className=" text-textBrandBlue font-medium cursor-pointer "
                        >
                            View
                        </p>

                        <div>
                            {address ? (
                                <Modal>
                                    <Modal.Button
                                        className="flex gap-2 cursor-pointer items-center"
                                        opens={'acceptingcreationrequest'}
                                    >
                                        <Button variant="tertiary" size="adjustLarge">
                                            Accept Request
                                        </Button>
                                    </Modal.Button>
                                    <Modal.Window name={'acceptingcreationrequest'}>
                                        <AcceptRequestModal
                                            reqFor="validation"
                                            bountyId={overviewrow.bountyId}
                                            multiSig={multiSig}
                                            afterRequestOperation={onRequestingFilterData}
                                            reqId={overviewrow._id}
                                        />
                                    </Modal.Window>
                                </Modal>
                            ) : (
                                <div className="w-full flex items-center">
                                    <WalletConnectCustomButton
                                        customText={'Accept Request'}
                                        width="177px"
                                        customStyles={{
                                            backgroundColor: 'white',
                                            color: '#1c1c1c',
                                            border: '1px solid #dcdcdc',
                                            lineHeight: 'normal',
                                            fontWeight: '500',
                                            paddingLeft: '12px',
                                            paddingRight: '12px',
                                            height: '41.6px',
                                            borderRadius: '8px',
                                            flexGrow: 1,
                                        }}
                                        connectedText={'Accept Request'}
                                        disconnectedText="Accept Request"
                                        removeIconOnDisconnect={true}
                                        removeIconOnConnect={true}
                                        removeIconOnWalletSelect={true}
                                        removeIconOnConnecting={true}
                                    />
                                </div>
                            )}
                        </div>

                        {/* <Modal>
                            <Modal.Button
                                className="flex gap-2 cursor-pointer items-center"
                                opens={'acceptingvalidationrequest'}
                            >
                                <Button variant="tertiary" size="large">
                                    Accept Request
                                </Button>
                            </Modal.Button>
                            <Modal.Window name={'acceptingvalidationrequest'}>
                                <AcceptRequestModal reqId={overviewrow._id} />
                            </Modal.Window>
                        </Modal> */}
                    </Table.Row>
                ))
            ) : (
                <NoDataAvailable />
            )}
        </>
    );
}

export default BountyValidationRequests;
